import { OPEN_CHAT, CLOSE_CHAT, LOADED_CHAT } from '../actionTypes/chat';

export const openChat = () => ({
    type: OPEN_CHAT
});

export const closeChat = () => ({
    type: CLOSE_CHAT
});

export const loadedChat = payload => ({
    type: LOADED_CHAT,
    payload
});
